import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmployeeChecklistDto } from '../models/employee/employeeChecklistDto';
import { StandardChecklistDto } from '../models/employee/standardChecklistDto';
import { EmployeeChecklistItemDto } from '../models/employee/employeeChecklistItemDto';
import { UpdatedChecklistInfoDto } from '../models/employee/updatedChecklistInfoDto';

@Injectable({
  providedIn: 'root',
})
export class EmployeeTodoService {
  private API = '/api/employeeTodo';

  constructor(private http: HttpClient) {}

  createEmployeeTodo(
    todo: Partial<EmployeeChecklistDto>
  ): Observable<EmployeeChecklistDto> {
    return this.http.post<EmployeeChecklistDto>(`${this.API}/create`, todo);
  }

  exportChecklists(tenantId: string): Observable<Blob> {
    return this.http.get(`${this.API}/export-checklists/${tenantId}`, {
      responseType: 'blob',
    });
  }

  createStandardChecklist(
    tenantId: string,
    checklist: Partial<StandardChecklistDto>
  ): Observable<StandardChecklistDto> {
    return this.http.post<StandardChecklistDto>(
      `${this.API}/create-standard/${tenantId}`,
      checklist
    );
  }

  getEmployeeTodos(
    userId: string,
    tenantId: string
  ): Observable<EmployeeChecklistDto[]> {
    return this.http.get<EmployeeChecklistDto[]>(
      `${this.API}/by-id/${userId}/${tenantId}`
    );
  }

  getStandardChecklists(tenantId: string): Observable<StandardChecklistDto[]> {
    return this.http.get<StandardChecklistDto[]>(
      `${this.API}/standard/${tenantId}`
    );
  }

  editChecklistStatus(
    data: EmployeeChecklistDto,
    userId: string,
    newStatus: boolean
  ): Observable<void> {
    return this.http.post<void>(`${this.API}/edit-status/${userId}`, {
      data,
      newStatus,
    });
  }

  editItemStatus(
    itemData: EmployeeChecklistItemDto,
    newStatus: boolean,
    userId: string
  ): Observable<UpdatedChecklistInfoDto> {
    return this.http.post<UpdatedChecklistInfoDto>(
      `${this.API}/edit-item-status/${userId}`,
      {
        itemData,
        newStatus,
      }
    );
  }

  deleteEmployeeTodo(id: string): Observable<void> {
    return this.http.delete<void>(`${this.API}/delete/${id}`);
  }

  deleteStandardChecklist(tenantId: string, id: string): Observable<void> {
    return this.http.delete<void>(
      `${this.API}/delete-standard/${tenantId}/${id}`
    );
  }
}
